import { environment } from 'src/environments/environment'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup
} from '@angular/forms'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { combineLatest, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { AccessRights } from 'src/app/features/role/user-role/user-role'

@Component({
  selector: 'registration-category-filter-card',
  templateUrl: './registration-category-filter-card.component.html',
  styleUrls: ['./registration-category-filter-card.component.scss']
})
export class RegistrationCategoryFilterCardComponent implements OnInit {
  @Input() formValues: any
  @Input() regCategorieOptions$: Observable<any>
  @Output() onSubmit = new EventEmitter<any>()
  public isCollapsedRegCategoryFilter = true
  public form: UntypedFormGroup
  public options$: Observable<any[]>
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private notificationService: NotificationService,
    private actions$: Actions
  ) {}

  get regCategoryFilterOptionsFormArray() {
    return this.form?.controls?.options as UntypedFormArray
  }

  ngOnInit() {
    this.options$ = combineLatest([
      this.regCategorieOptions$,
      this.store.select(settingSelectors.selectById, 'language')
    ]).pipe(
      map(([catOptions, language]) => {
        return catOptions?.options?.map((option) => {
          return {
            ...option,
            name: option[`name_${language}`]
          }
        })
      })
    )

    this.form = this.fb.group({
      description_nl: [null, []],
      description_en: [null, []],
      description_fr: [null, []],
      description_de: [null, []],
      options: this.fb.array([])
    })

    if (this.formValues) {
      const optionSets = this.formValues.options

      optionSets.map(() =>
        this.regCategoryFilterOptionsFormArray?.length < optionSets?.length
          ? this.addRegCatFilterOptionRow()
          : null
      )

      this.form?.patchValue(this.formValues)
    }
  }

  public getRegCatFilterOptionsRow() {
    return this.fb.group({
      name_en: [''],
      name_nl: [''],
      name_fr: [''],
      name_de: [''],
      belongingCategories: [''],
      ordinal: ['']
    })
  }

  public addRegCatFilterOptionRow() {
    this.regCategoryFilterOptionsFormArray.push(
      this.getRegCatFilterOptionsRow()
    )
  }

  public deleteRegCatFilterOptionRow(index): void {
    this.regCategoryFilterOptionsFormArray.removeAt(index)
  }

  public onSubmitRegistrationCategoryFilter() {
    this.onSubmit.emit({
      key: 'registration_category_filter',
      valueToSave: JSON.stringify(this.form.value, null, 4)
    })
  }
}
